module.exports = __webpack_public_path__ + "img/ms_kv_ill.50f747ca.png";